const filteredScopesByService = (user, service) => {
    let filteredScopes = [];

    if (!user.oauth_profile) return [];

    user.scopes.forEach((scope) => {
        if (scope === 's2e') {
            if (!user.disabled_scopes?.s2e?.includes(service)) {
                filteredScopes.push(scope);
            }
        } else {
            filteredScopes.push(scope);
        }
    });

    return filteredScopes;
};

export default filteredScopesByService;
